import config from "@/config";
import Axios from "@/utils/Axios";
import { DraftParams } from "./types";

export const postDraftTask = (params: DraftParams) => {
  return Axios.post("/draft/push", params, {}, config.aiCreator);
};
